var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNextButtonGallery(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Komponente_182_1",
    "data-name": "Komponente 182 \\u2013 1",
    transform: "translate(40) rotate(90)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1908",
    "data-name": "Ellipse 1908",
    cx: 20,
    cy: 20,
    r: 20,
    transform: "translate(0 40) rotate(-90)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_22903",
    "data-name": "Rechteck 22903",
    width: 40,
    height: 40,
    transform: "translate(40) rotate(90)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_232329",
    "data-name": "Pfad 232329",
    d: "M-14095.983,15042.543v-10h10",
    transform: "translate(20616.979 -647.248) rotate(45)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextButtonGallery);
export default __webpack_public_path__ + "static/media/next_button_gallery.0963065b0367e62d8040aceb9759925e.svg";
export { ForwardRef as ReactComponent };